import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e11c32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pack-track-box" }
const _hoisted_2 = {
  key: 1,
  class: "empty-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.load)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_descriptions, {
            column: 2,
            border: "",
            size: "small",
            class: "info-box"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "物流公司" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.expressName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "运单号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.expressBill), 1)
                ]),
                _: 1
              }),
              (_ctx.receiverName || _ctx.receiverMobile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_descriptions_item, { label: "收货人" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.receiverName || '--'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "收货人电话" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.receiverMobile || '--'), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.receiverAddress)
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 1,
                    label: "收货地址",
                    span: 2
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.receiverAddress), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.trackList.length)
            ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                      key: i,
                      placement: "top",
                      type: i === 0 ? 'success' : '',
                      timestamp: _ctx.trackTime(item) || '--'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.trackContext(item) || '--'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "timestamp"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, "暂无物流轨迹"))
        ], 64))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}